import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, MapPin } from 'lucide-react';
interface Sale {
  name: string;
  location: string;
  timeAgo: string;
}
const salesData: Sale[] = [{
  name: 'María G.',
  location: 'Madrid, España',
  timeAgo: 'hace 3 minutos'
}, {
  name: 'Carmen R.',
  location: 'Ciudad de México, México',
  timeAgo: 'hace 8 minutos'
}, {
  name: 'Ana L.',
  location: 'Buenos Aires, Argentina',
  timeAgo: 'hace 12 minutos'
}, {
  name: 'Laura M.',
  location: 'Bogotá, Colombia',
  timeAgo: 'hace 15 minutos'
}, {
  name: 'Patricia S.',
  location: 'Lima, Perú',
  timeAgo: 'hace 18 minutos'
}, {
  name: 'Isabel F.',
  location: 'Santiago, Chile',
  timeAgo: 'hace 22 minutos'
}, {
  name: 'Rosa V.',
  location: 'Barcelona, España',
  timeAgo: 'hace 25 minutos'
}, {
  name: 'Sofía P.',
  location: 'Guadalajara, México',
  timeAgo: 'hace 28 minutos'
}, {
  name: 'Elena C.',
  location: 'Valencia, España',
  timeAgo: 'hace 31 minutos'
}, {
  name: 'Lucía H.',
  location: 'Monterrey, México',
  timeAgo: 'hace 35 minutos'
}];
export function SalesNotificationPopup() {
  const [currentSale, setCurrentSale] = useState<Sale | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showNotification = () => {
      const randomSale = salesData[Math.floor(Math.random() * salesData.length)];
      setCurrentSale(randomSale);
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Show first notification after 3 seconds
    const initialTimeout = setTimeout(showNotification, 3000);
    // Then show every 15 seconds
    const interval = setInterval(showNotification, 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-270">
      {isVisible && currentSale && <motion.div initial={{
      opacity: 0,
      x: -100,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -100,
      y: 20
    }} transition={{
      type: 'spring',
      stiffness: 200,
      damping: 25
    }} className="fixed bottom-6 left-6 z-40 max-w-sm" data-id="element-271">
          <div className="bg-white rounded-xl shadow-2xl border border-gray-100 p-4 flex items-start gap-3" data-id="element-272">
            {/* Icon */}
            <div className="flex-shrink-0 w-10 h-10 bg-[#48BB78] rounded-full flex items-center justify-center" data-id="element-273">
              <ShoppingBag className="w-5 h-5 text-white" data-id="element-274" />
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-275">
              <p className="text-sm font-bold text-gray-900 mb-1" data-id="element-276">
                ¡{currentSale.name} acaba de comprar!
              </p>
              <div className="flex items-center gap-1 text-xs text-gray-500 mb-1" data-id="element-277">
                <MapPin className="w-3 h-3" data-id="element-278" />
                <span data-id="element-279">{currentSale.location}</span>
              </div>
              <p className="text-xs text-gray-400" data-id="element-280">{currentSale.timeAgo}</p>
            </div>

            {/* Close button */}
            <button onClick={() => setIsVisible(false)} className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Cerrar notificación" data-id="element-281">
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-282">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-283" />
              </svg>
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}